function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.24796 0C4.14877 0 0 4.14877 0 9.24796C0 14.3474 4.14877 18.4959 9.24796 18.4959C14.3474 18.4959 18.4959 14.3474 18.4959 9.24796C18.4959 4.14877 14.3474 0 9.24796 0ZM9.24796 16.7886C5.09008 16.7886 1.70732 13.4059 1.70732 9.248C1.70732 5.09012 5.09008 1.70732 9.24796 1.70732C13.4058 1.70732 16.7886 5.09008 16.7886 9.24796C16.7886 13.4058 13.4058 16.7886 9.24796 16.7886Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.75 19.5428L15.8557 14.6485C15.5222 14.315 14.9821 14.315 14.6486 14.6485C14.3151 14.9817 14.3151 15.5223 14.6486 15.8556L19.5429 20.7499C19.7096 20.9166 19.9279 21 20.1464 21C20.3647 21 20.5832 20.9166 20.75 20.7499C21.0835 20.4167 21.0835 19.876 20.75 19.5428Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 21,
  fill: "white"
})));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Search.17c23cdb.svg";
export { ForwardRef as ReactComponent };